import {HandleShape} from './handle-shape';

export class DoorShape {

    constructor(canvas, options) {

        this._canvas = canvas;
        this._door = options.door;
        this._points = options.points || [];
        this._editable = options.editable || false;
        this._onClick = options.onClick || function() {};
        this._onDrag = options.onDrag || function() {};
        this._onDragStart = options.onDragStart || function() {};
        this._onDragEnd = options.onDragEnd || function() {};

        // create polygon
        this._shape = this._canvas.polygon().attr({
            strokeWidth: 2,
            class: 'door',
            points: this._points
        });

        if (this._editable) this._shape.addClass('editable');

        this._shape.mousedown((e) => {
            e.stopPropagation();
            this.toggleSelect(true);
            this._onClick(this);
        });

        this._handles = [];

        if (this._editable) {

            this._shape.drag(this.onDoorShapeDrag, this.onDoorShapeDragStart, this.onDoorShapeDragEnd, this, this);

            for (let i = 0; i < 8; i+=2) {

                let handle = new HandleShape(
                    this._canvas,
                    {
                        x: this._points[i],
                        y: this._points[i+1],
                        onDrag: this.onHandleDrag.bind(this),
                        onDragStart: this.onHandleDragStart.bind(this),
                        onDragEnd: this.onHandleDragEnd.bind(this)
                    }
                );

                this._handles.push(handle);

            }

        }


        if (this._editable) this.toggleSelect(options.selected);

    }

    onDoorShapeDrag(dx, dy) {

        let points = this._tempPoints.map((point, index) => {

            if (index % 2 === 0) {
                return parseFloat(point) + dx;
            } else {
                return parseFloat(point) + dy;
            }

        });

        this.updatePosition(points);
        this._onDrag(this);

    }

    onDoorShapeDragStart() {
        this.toggleSelect(true);
        this._tempPoints = this._points;
        this._onDragStart(this);
    }

    onDoorShapeDragEnd() {
        this._onDragEnd(this);
    }

    onHandleDrag() {
        let points = [];

        this._handles.forEach((handle) => {
            points.push(handle.getPosition().x);
            points.push(handle.getPosition().y);
        });

        this.updatePosition(points, false);

        this._onDrag(this);
    }

    onHandleDragStart() {
        this._onDragStart(this);
    }

    onHandleDragEnd() {
        this._onDragEnd(this);
    }

    updatePosition(points, updateHandles = true) {

        this._points = points;

        this._shape.attr('points', this._points);

        if (updateHandles) {

            let i = 0;

            this._handles.forEach((handle) => {

                handle.setPosition({x: this._points[i], y: this._points[i + 1]});

                i += 2;

            });

        }

    }

    toggleSelect(val) {

        if (val) {
            this._shape.addClass('selected');
            if (this._editable) {
                this.showHandles();
            }
        } else {
            this._shape.removeClass('selected');
            if (this._editable) {
                this.hideHandleShapes();
            }
        }

    }

    showHandles() {
        this._handles.forEach((handle) => {
            handle.show();
        });
    }

    hideHandleShapes() {
        this._handles.forEach((handle) => {
            handle.hide();
        });
    }

    remove() {
        this._shape.remove();

        this._handles.forEach((handle) => {
            handle.remove();
        });
    }

    getPoints() {
        return this._points;
    }

    getDoor() {
        return this._door;
    }

}



// WEBPACK FOOTER //
// ./src/js/components/design-preview/door-shape.js